<div aria-busy="true">
  <header class="caption surface-0 p-3 flex align-items-start gap-3">
    <div class="flex flex-column gap-2 flex-1">
      <p-skeleton width="18rem" height="1.4rem" styleClass="max-w-full" />
      <p-skeleton width="8rem" height="1rem" />
    </div>
    <div class="flex gap-2 mt-1">
      <p-skeleton class="hidden sm:block" shape="circle" size="1.6rem" />
      <p-skeleton class="hidden sm:block" shape="circle" size="1.6rem" />
      <p-skeleton shape="circle" size="1.6rem" />
      <p-skeleton shape="circle" size="1.6rem" />
      <p-skeleton shape="circle" size="1.6rem" />
    </div>
  </header>

  <div class="content">
    <app-atlas-grid-skeleton [widgetsOnly]="true" />
  </div>

  <span class="navigator left-0 ml-3"></span>
  <span class="navigator right-0 mr-3"></span>

  <footer class="indicators surface-0 flex justify-content-center gap-2">
    @for (indicator of indicators; track indicator) {
      <span
        class="indicator border-circle"
        [class.active]="indicator === 0"></span>
    }
  </footer>
</div>
